import get from 'lodash/get';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Provider, useQuery } from 'urql';

import * as D from '../../../deps';

import BackstageCuratorContent from './BackstageCuratorContent';

const BackstageCuratorDataFetcher = props => {
  const { pandoraId } = props.params;
  const [{ data, fetching, error }] = useQuery({
    query: D.GraphQL.Queries.getCuratorDetails,
    variables: { pandoraId },
  });

  const curatedStations = get(data, 'entity.curatedStations.items', []);
  const curatedPlaylists = get(data, 'entity.playlists.items', []);

  const firstStationId = get(curatedStations[0], 'pandoraId', null);
  const firstPlaylistId = get(curatedPlaylists[0], 'pandoraId', null);

  const playablePandoraId = firstStationId || firstPlaylistId;
  const hasPlayableContent = !!playablePandoraId;
  const playableContentType = firstStationId ? D.PandoraTypes.STATION : D.PandoraTypes.PLAYLIST;

  const curatorProps = {
    pandoraId,
    name: get(data, 'entity.name', ''),
    bio: get(data, 'entity.bio', ''),
    curatorUrl: get(data, 'entity.url', null),
    artUrl: get(data, 'entity.art.artUrl', null),
    headerArtUrl: get(data, 'entity.art.headerArtUrl', ''),
    listenerCount: get(data, 'entity.listenerCount', null),
    playablePandoraId,
    hasPlayableContent,
    playableContentType,
    curatedStations,
    curatedPlaylists,
    socialLinks: {
      twitterUrl: get(data, 'entity.twitterUrl', ''),
      instagramUrl: get(data, 'entity.instagramUrl', ''),
      facebookUrl: get(data, 'entity.facebookUrl', ''),
      websiteUrl: get(data, 'entity.websiteUrl', ''),
    },
    isLoaded: !error && !fetching && !!data,
  };

  if (error) {
    props.openServiceErrorToast();
    return <BackstageCuratorContent {...curatorProps} />;
  }
  if (props.children) {
    return <BackstageCuratorContent {...curatorProps}>{props.children}</BackstageCuratorContent>;
  }
  return <BackstageCuratorContent {...curatorProps} />;
};

BackstageCuratorDataFetcher.propTypes = {
  children: PropTypes.element,
  openServiceErrorToast: PropTypes.func,
  params: PropTypes.shape({
    pandoraId: PropTypes.string,
  }).isRequired,
};

const mapDispatchToProps = {
  openServiceErrorToast: D.Actions.Modal.openServiceErrorToast,
};

export const BackstageCuratorProvider = props => {
  return (
    <Provider value={D.GraphQL.UrqlClient}>
      <BackstageCuratorDataFetcher {...props} />
    </Provider>
  );
};

export default connect(null, mapDispatchToProps)(BackstageCuratorProvider);
